"use client";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import { IMedia, pxToRem } from "@/util";
import Image from "next/image";
import { AppColors } from "@/assets/colors";
import { IBlog } from "@/util/types/blog";

type props = {
  isLoading: boolean;
  data: IBlog;
};

export default function Preview({ isLoading = false, data }: Partial<props>) {
  const { classes } = styles();

  return (
    <Paper className={classes.uploadPaper}>
      <Box className={classes.intro}>
        {isLoading ? (
          <Skeleton className={classes.date} />
        ) : (
          <Typography className={classes.date}>
            {data?.createdAt?.toString().split("T")[0]}
          </Typography>
        )}
        <Box className={classes.view}>
          <Image
            src="/images/dashboard/blog/vieweye.svg"
            alt="view icon"
            width={20}
            height={20}
            priority
          />
          {isLoading ? (
            <Skeleton className={classes.blogView} />
          ) : (
            <Typography className={classes.blogView}>
              {data?.views} views
            </Typography>
          )}
        </Box>
      </Box>
      {isLoading ? (
        <Skeleton className={classes.blogName} />
      ) : (
        <Typography className={classes.blogName}>{data?.title}</Typography>
      )}
      {isLoading ? (
        <Skeleton className={classes.imageContainer} />
      ) : (
        <Box className={classes.imageContainer}>
          {data?.coverImage && (
            <Image
              src={`${(data.coverImage as IMedia).url}`}
              alt="blog image"
              fill
              style={{ objectFit: "cover", objectPosition: "center" }}
              priority
            />
          )}
        </Box>
      )}
      {isLoading ? (
        <Skeleton className={classes.blogContent} />
      ) : (
        <Box
          className={classes.blogContent}
          dangerouslySetInnerHTML={{ __html: data?.content ?? "" }}
        />
      )}
    </Paper>
  );
}

const styles = makeStyles()((theme) => ({
  uploadPaper: {
    padding: `${pxToRem(40)} ${pxToRem(80)}`,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(30)} ${pxToRem(20)}`,
    },
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    aspectRatio: "16 / 9",
    overflow: "hidden",
    marginBottom: pxToRem(40),
  },
  //   view
  blogView: {
    fontSize: pxToRem(20),
  },
  listContent: {},
  view: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  intro: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: theme.spacing(3),
    // margin: `${pxToRem(30)} ${pxToRem(0)} `,
  },
  //   BLog Details
  blogName: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    lineHeight: "120%",
    fontSize: pxToRem(45),
    color: AppColors.text.default,
    margin: `${pxToRem(20)} ${pxToRem(0)} `,
  },
  blogContent: {
    fontFamily: "General Sans",
    fontWeight: 400,
    lineHeight: "160%",
    fontSize: pxToRem(22),
    color: AppColors.text.default,
  },
  blogSubheading: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    lineHeight: "120%",
    margin: `${pxToRem(30)} ${pxToRem(0)} `,
    fontSize: pxToRem(30),
    color: AppColors.text.default,
  },
  date: {
    fontSize: pxToRem(20),
  },
  consultation: {
    color: AppColors.primary["300"],
    textDecoration: "underline",
    fontWeight: 700,
    lineHeight: "160%",
    fontSize: pxToRem(28),
  },
}));
